module.exports = __webpack_public_path__ + "static/media/ic-our-experts-ex.841507c9.png";